<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header"; 
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    treeselect
  },
  data() {
    return { 
      title: this.$t("userroles.Title"),
      items: [
        {
          text: this.$t("userroles.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      //Kullanicilar: {},
      KullanicilarTable: {},
      KullaniciRolleriGrup: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      YetkiAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles:[],
      KullanicilarArray:[],
      YetkiArray:[ ],
      Tab:1,
      KullaniciAvatar: null
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  watch:{
    KullaniciAra(){
      this.KullaniciAvatar = this.KullanicilarArray.filter(notification => notification.id.includes(this.KullaniciAra)); 
    }
  },
  methods: {

    loadOptions({ action,  callback }) {      
      if (action === ASYNC_SEARCH) {
        
          simulateAsyncOperation(() => {
             this.options = this.KullanicilarArray;
          callback(null, this.options)
          
        })
       
      }
    },

    Get() {

      this.KullaniciRolleri = [ ];


      this.ActionsGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-roles",
        Page: this.PageToplu,
      }).then((res) => {
        res.Data = res.Data.sort(function (a, b) {return a.Title.localeCompare(b.Title);}); 
        this.KullaniciRolleriGrup = this.groupBy(res.Data, "Group");
        this.KullaniciRolleri = res.Data; 
        for(let i=0; i<res.Data.length; i++){  
          if(res.Data[i].Group == "Strateji Bilgi Sistemi"){
                this.YetkiArray.push({
                id: res.Data[i].NormalizedName,
                label: res.Data[i].Name,
              });
          }
        }
      });
      
     // this.kullanici_yukle();
    },

    kullanici_yukle( name ){

      if (name.length>2){
          //this.Kullanicilar=[];
          this.KullanicilarArray=[];
          let Page = {
            PageNumber: "1",
            PageSize: "50",
          };
          let Filter="&name="+name
          this.ActionsFilterGet({
            Service: this.$config.API_ACCOUNT_URL + "Account/get-users",
            Page: Page,
            Filter:Filter
          }).then((res) => {
            //this.Kullanicilar = res.Data;
            for(let i=0; i<res.Data.length; i++){  
              this.KullanicilarArray.push({
              id: res.Data[i].Email,
              label: res.Data[i].FirstName+" "+res.Data[i].LastName,
              avatar: res.Data[i].AvatarUrl
            });
            }
          });

          /*
          this.ActionsGet({
            Service: this.$config.API_ACCOUNT_URL + "Account/get-users",
            Page: this.Page,
          }).then((res) => {
            this.KullanicilarTable = res.Data;
            this.Page.PageDataSize = res.TotalCount;
          }); */

    }

    },

    KullaniciYetkiSorgu(kullanici) {
      this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
        Page: this.PageToplu,
        Filter: "&email=" + kullanici,
      }).then((res) => {
        this.SeciliKullaniciYetkileri = res.Data;


        if (Array.isArray(res.Data.Roles)) {
          this.Roles = res.Data.Roles
          
        } else {
          this.Roles=[];  
        }

      });
    },

    YetkiKullaniciSorgu(yetki) { 
      this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-users-in-role",
        Page: this.PageToplu,
        Filter: "&role=" + yetki,
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },

    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },

    RolesPost(checked,value) {  
          let FormData = {
            Email: this.SeciliKullaniciYetkileri.Email,
            Role: value,
          }; 
      if(checked == true){ 
          this.Post(
            this.$config.API_ACCOUNT_URL + "Account/add-userroles",
            FormData
          );
      }else{
          this.Post(
            this.$config.API_ACCOUNT_URL + "Account/delete-userroles",
            FormData
          );
      }
    },

  },
};
</script>

<template>
  <Layout>


    <PageHeader title="" :items="items" /> 
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active @click="Tab=1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block" >{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p>  
                  <div class="col-lg-12"> 
                     <treeselect
                      :clear-search-on-select="true"
                      :load-options="loadOptions"
                      placeholder="Seçiniz..."
                      name="KullaniciAra"
                      v-model="KullaniciAra" 
                      :cacheOptions="false"
                      :multiple="false"
                      searchPromptText="Aramak için yazın..."
                      @search-change="kullanici_yukle($event)"
                      :async="true"
                      @select="KullaniciYetkiSorgu($event.id)"
                      />
                  
                  </div>
                </div>
              </b-tab>

              <b-tab  @click="Tab=2">
                <template v-slot:title  >
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"  >{{
                    $t("userroles.page.yetkilistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.yetkiler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkiyebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :options="YetkiArray"
                      placeholder="Seçiniz..."
                      v-model="YetkiAra" 
                      @select="YetkiKullaniciSorgu($event.id)"
                      /> 
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab ==1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc"> 
            <img v-if="KullaniciAvatar[0].avatar" class="rounded-circle header-profile-user" :src="KullaniciAvatar[0].avatar ? $config.AVATAR_URL+KullaniciAvatar[0].avatar : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='" />
            {{ this.$t("userroles.page.ekampusicin") }}
            <code>{{ KullaniciAra }}</code>
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div
              class="col-lg-4"
              v-for="(RollerGrup, index) in KullaniciRolleriGrup"
              :key="index"
            >
              <div class="mt-4 mt-lg-0" v-if="RollerGrup[0].Group == 'Strateji Bilgi Sistemi'">
                <h5 class="font-size-14 mb-3 w-100">
                  {{ RollerGrup[0].Group }}
                </h5>

                <div
                  class="form-check form-switch form-switch-md mb-3"
                  v-for="(Roller, index) in RollerGrup"
                  :key="index"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :id="Roller.Name"
                    v-model="Roles"
                    :value="Roller.Name"
                    @input="RolesPost($event.target.checked,$event.target.value)"
                  />
                  <label class="form-check-label" for="customSwitchsizemd">{{
                    Roller.Title
                  }}</label>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="YetkiAra && Tab ==2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            <code>{{ YetkiAra }}</code>
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SeciliYetkiKullaniciliari"
                  :key="index"
                >
                  <td>{{ Kullanici.FirstName }}</td>
                  <td>{{ Kullanici.LastName }}</td>
                  <td>{{ Kullanici.Email }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
